// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2h-1";
export var movingGradient = "_2h-4";
export var movingGradientBlock = "_2h-2";
export var skeleton = "_2h-0";
export var skeletonText = "_2h-3";